const datePickerLocalization = {
  today: '今日',
  clear: '清除選擇',
  close: '關閉',
  selectMonth: '選擇月份',
  previousMonth: '上個月',
  nextMonth: '下個月',
  selectYear: '選擇年份',
  previousYear: '上一年',
  nextYear: '下一年',
  selectDecade: '選擇十年',
  previousDecade: '上一個十年',
  nextDecade: '下一個十年',
  previousCentury: '上一個世紀',
  nextCentury: '下一個世紀',
  pickHour: '選擇小時',
  incrementHour: '增加小時',
  decrementHour: '減少小時',
  pickMinute: '選擇分鐘',
  incrementMinute: '增加分鐘',
  decrementMinute: '減少分鐘',
  pickSecond: '選擇秒數',
  incrementSecond: '增加秒數',
  decrementSecond: '減少秒數',
  toggleMeridiem: '切換上午/下午',
  selectTime: '選擇時間',
  selectDate: '選擇日期',
  dayViewHeaderFormat: { month: 'long', year: 'numeric'},
  locale: 'zh-tw',
};

export {datePickerLocalization};
